<template>
  <div>
<!--     <CModal
      id="error-notification"
      title="Notification"
      :show.sync="showErrorMessage"
    >
      {{errorMessage}}
    </CModal>
    <div 
      id="app-spinner-wrapper"
      v-bind:style="[displaySpinner ? {display: ''} : {display: 'none'}]"
    >
      <c-spinner 
        id="app-spinner"
        color="primary"
      />  
    </div> -->
    <router-view></router-view>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

const PageRouter = () => import('@/page-lib/components/PageRouter')

export default {
  name: 'App',
  data() {
    return {
      showErrorMessage: false,
      displaySpinner: false,
      errorMessage: '',
    }
  },
  computed: mapState({
    pages: state => state.page.pages,
  }),
  methods: {
    ...mapActions({
      listPages: 'page/listPages',
    }),
  },
  created () {
    this.listPages().then(() => {
      const dynamicRouters = []
      for (const page of this.pages) {
        dynamicRouters.push({
          path: page.path,
          name: page.name,
          component: PageRouter,
        })
      }
      this.$router.addRoutes(dynamicRouters)
    })
  },
  watch: {
  },
}
</script>

<style lang="scss">
  // Import Main styles for this application
  @import 'assets/scss/style';

  #app-div #error-notification .modal-footer {
    display: none;
  }
  #app-spinner-wrapper {
    z-index: 999;
    position: fixed;
    width: 100%;
    height:100%;
    display: flex;
    align-items: center;
    top: 0;
    background-color: #eee;
    opacity: 0.5;
  }
  #app-spinner {
    width: 4rem;
    height: 4rem;
    display: flex;
    margin: 0 auto;
  }

  .invisible {
    display: none;
  }
</style>